/* eslint-disable jsx-a11y/anchor-is-valid */
import PropTypes from 'prop-types'
import { truncate } from 'lodash'
import { withRouter } from 'next/router'
import { Link } from '~/i18n'

import TopicsPills from '~/components/shared/TopicsPills'
import RelatedCard from '~/components/shared/RelatedCard'
import UserMedia from '~/components/shared/UserMedia'

import styles from './index.module.scss'
import { EmailPropType } from '~/utils/prop-types'

// TODO: use OrganizationLink
const EmailRelatedCard = ({ email, router }) => (
  <RelatedCard>
    {!!email.fromRedacted && (
      <div className="mb-3">
        <UserMedia value={email} isRelated />
      </div>
    )}
    <Link prefetch={false} href={`/organizations/${router.query.slug}/emails/${email.id}`}>
      <a className={styles.link}>
        <h3 className={styles.subject}>
          {email.subjectRedacted}
        </h3>
        <p className={styles.body}>
          {truncate(email.bodyPlainRedacted, { length: 210 })}
        </p>
      </a>
    </Link>
    <TopicsPills topics={email?.topics?.nodes} className="mt-2" />
  </RelatedCard>
)

EmailRelatedCard.propTypes = {
  email: EmailPropType.isRequired,
  router: PropTypes.shape({
    query: PropTypes.shape({
      slug: PropTypes.string.isRequired,
    }).isRequired
  }).isRequired
}

export default withRouter(EmailRelatedCard)
